export default __webpack_public_path__ + "static/logo-22df878ab616f41aeb5485786efd6d07.svg";